import { createSlice } from '@reduxjs/toolkit';
import { EsicBranchState } from './branchTypes';
import {
  createEsicBranch,
  fetchEsicBranchList,
  fetchEsicBranchById,
  updateEsicBranch,
  deleteEsicBranch,
} from './branchAction';

const initialState: EsicBranchState = {
  branchList: [],
  selectedBranch: undefined,
  loading: false,
  error: undefined,
};

const esicBranchSlice = createSlice({
  name: 'esicBranch',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create
      .addCase(createEsicBranch.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(createEsicBranch.fulfilled, (state, action) => {
        state.loading = false;
        state.branchList.push({ ...action.meta.arg, branch_id: action.payload.id });
      })
      .addCase(createEsicBranch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch All
      .addCase(fetchEsicBranchList.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchEsicBranchList.fulfilled, (state, action) => {
        state.loading = false;
        state.branchList = action.payload.data;
      })
      .addCase(fetchEsicBranchList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch By ID
      .addCase(fetchEsicBranchById.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchEsicBranchById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedBranch = action.payload;
      })
      .addCase(fetchEsicBranchById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update
      .addCase(updateEsicBranch.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(updateEsicBranch.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.branchList.findIndex((item) => item.branch_id === action.meta.arg.id);
        if (index !== -1) {
          state.branchList[index] = { ...state.branchList[index], ...action.meta.arg };
        }
      })
      .addCase(updateEsicBranch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Delete
      .addCase(deleteEsicBranch.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(deleteEsicBranch.fulfilled, (state, action) => {
        state.loading = false;
        state.branchList = state.branchList.filter(
          (item) => item.branch_id !== action.meta.arg
        );
      })
      .addCase(deleteEsicBranch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default esicBranchSlice.reducer;
